<div class="dm-progress-bar">
  <ng-container *ngFor="let step of progressBarData; let index = index">
    <div class="step" [ngClass]="getClassByStatus(step.status)">
      <div class="custom-tooltip icon" [ngClass]="getIconByStatus(step.status)">
        <div class="custom-tooltiptext font-caption-alt" placement="top">{{step.content}}</div>
      </div>
    </div>
  </ng-container>
</div>